import { nowUnixTimestamp, curry } from '../../../utils/helpers.mjs';
import { SOUND_EDITION_V2_ABI } from '../abi/sound-edition-v2.mjs';
import { getTierCurrentMaxMintable, getSuperMinterForEdition } from './helpers.mjs';
import { isSoundV2 } from './interface.mjs';

async function editionContractInfo(client, {
  editionAddress
}) {
  const data = await client.readContract({
    abi: SOUND_EDITION_V2_ABI,
    address: editionAddress,
    functionName: "editionInfo"
  });
  return {
    ...data,
    tierInfo: data.tierInfo.map((tierInfo) => ({
      ...tierInfo,
      maxMintable: tierInfo.maxMintableLower === tierInfo.maxMintableUpper ? tierInfo.maxMintableLower : (unixTimestamp) => getTierCurrentMaxMintable(tierInfo, unixTimestamp)
    }))
  };
}
async function mintingSchedules(client, { editionAddress, unixTimestamp = nowUnixTimestamp() }) {
  const { address, abi } = await getSuperMinterForEdition(client, { editionAddress });
  const schedules = await client.readContract({
    abi,
    address,
    functionName: "mintInfoList",
    args: [editionAddress]
  }).then(
    (schedules2) => schedules2.map((schedule) => ({
      ...schedule,
      mode: schedule.mode === 0 ? "DEFAULT" : schedule.mode === 1 ? "VERIFY_MERKLE" : "VERIFY_SIGNATURE",
      minterAddress: address
    }))
  );
  const activeSchedules = schedules.filter((mintSchedule) => {
    return mintSchedule.startTime <= unixTimestamp && mintSchedule.endTime > unixTimestamp && !mintSchedule.paused;
  });
  return {
    schedules,
    activeSchedules
  };
}
function editionV2PublicActionsInfo(client) {
  return {
    editionV2: {
      ...client.editionV2,
      isSoundV2: curry(isSoundV2)(client),
      info: curry(editionContractInfo)(client),
      mintSchedules: curry(mintingSchedules)(client)
    }
  };
}

export { editionContractInfo, editionV2PublicActionsInfo, mintingSchedules };
